'use client';

import { usePathname } from 'next/navigation';
import { useMemo } from 'react';

import { adjustPathnameLocale, getUrlOrigin } from '@monoimin/utils/helpers';
import { IS_GOLDEN_VISA } from '@monoimin/constants';

export const StepMetaTags = ({ id, site }: { id: string; site?: MiniSlug }) => {
  const pathname = usePathname() || '/';

  const adjustedPathname = useMemo(() => {
    const withLocale = adjustPathnameLocale(pathname.replace(site + '/', ''));

    if (IS_GOLDEN_VISA && withLocale.endsWith('/')) {
      return withLocale.replace(/.$/, '');
    }
    if (IS_GOLDEN_VISA) {
      return withLocale;
    }
    if (withLocale.endsWith('/')) {
      return withLocale;
    }
    return withLocale + '/';
  }, [pathname]);

  const origin = getUrlOrigin(undefined, undefined, site);
  return (
    <div className='hidden' itemProp='url' data-testid='sb-how-to-step-url'>
      {origin + adjustedPathname + `#${id}`}
    </div>
  );
};
